import { Link } from 'react-router-dom';

interface FooterProps {
  t: any;
  lang: string;
}

export default function Footer({ t, lang }: FooterProps) {
  const l = (path: string) => {
    if (lang === 'EN') return path;
    const prefix = lang === 'JP' ? '/ja' : '/id';
    return `${prefix}${path === '/' ? '' : path}`;
  };

  return (
    <footer className="py-10 text-center text-sm text-gray-500 mt-auto border-t border-gray-100 max-w-[1200px] mx-auto w-full px-4">
      <div className="flex justify-center items-center gap-4 mb-3">
        <Link to={l("/privacy-policy")} className="hover:text-[#f1b43e] transition-colors">{t.privacy}</Link>
        <span className="text-gray-300">|</span>
        <Link to={l("/terms")} className="hover:text-[#f1b43e] transition-colors">{t.terms}</Link>
      </div>
      <p>Copyright © {new Date().getFullYear()} Faizi Zahari</p>
    </footer>
  );
}
